<template>
  <button
      class="flex justify-center shadow-md transform hover:-translate-y-1 duration-200 rounded-md cursor-pointer items-center pr-2 text-sm p-3"
      @click="requestByMail()">
          <email-icon class="p-1" />
          <h2 class="ml-4">
              {{ $t('product.onRequest')}}
          </h2>
  </button>
</template>

<script>
import EmailIcon from '@/components/graphics/EmailIcon.vue';
import AreYouSureOnRequestModal from '@/components/graphics/AreYouSureOnRequestModal.vue';
import { mapGetters } from 'vuex';

export default {
  props: {
    product: Object,
  },

  components: {
    EmailIcon,
  },

  computed: {
    ...mapGetters({
      authenticated: 'auth/authenticated',
    }),
  },

  methods: {
    requestByMail() {
      if (this.authenticated) {
        this.$modal.show(AreYouSureOnRequestModal, {
          product: this.product,
        }, { height: 'auto', adaptive: true });
      }
      if (!this.authenticated) {
        this.$router.push({ path: `/signin?redirect=${this.$route.fullPath}` });
      }
    },
  },
};
</script>
